
<div class="">
  <label v-if="label" class="mb-0 c-label" :class="labelClass">{{ label }} 
    <span v-if="required" style="font-size: 16px" class="text-danger font-weight-bold">*</span>
  </label>
  <div v-if="inputType === 'textarea'">
    <textarea 
      v-if="!iconSrc && id" 
      :id="`${id}`" 
      @focusin="setClass ? setClass(id) : ''" 
      @focusout="unsetClass ? unsetClass(id) : ''" 
      class="c-input" 
      :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
      :style="inputStyle" 
      :value="value" 
      :placeholder="placeholder" 
      :type="type" 
      @input="$emit('input',$event.target.value)" 
      :maxlength="maxlength" 
      style="height:80px;" 
      :readonly="readonly" 
      :required="required"
      :disabled="disabled"
    ></textarea>
    <textarea 
      v-else-if="!iconSrc && !id" 
      @focusin="setClass ? setClass(id) : ''" 
      @focusout="unsetClass ? unsetClass(id) : ''" 
      class="c-input" 
      :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
      :style="inputStyle" 
      :value="value" 
      :placeholder="placeholder" 
      :type="type" 
      @input="$emit('input',$event.target.value)" 
      :maxlength="maxlength" 
      style="height:80px;" 
      :readonly="readonly" 
      :required="required"
      :disabled="disabled"
    ></textarea>
    <div v-else>
      <textarea 
        v-if="id" 
        :id="`${id}`" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        style="padding-right: 50px;height:50px;" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled"
      ></textarea>
      <textarea 
        v-else @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        style="padding-right: 50px;height:50px;" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled"
      ></textarea>
      <img class="c-input-icon" :src="iconSrc">
    </div>
  </div>
  <div v-else>
    <div v-if="type === 'date'">
      <div class="date-picker-wrapper position-relative">
      <input
        class="c-input datepicker-masked"
        :value="formattedValue"
        :placeholder="placeholder"
        type="text"
        @input="onInput"
        @focus="isTyping = true"
        @blur="onBlur"
        :disabled="disabled"
        :class="inputClass"
        :required="required"
        :id="`${id}`" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        :style="inputStyle" 
        style="padding-right: 50px" 
        :maxlength="maxlength" 
        :min="inputMin" 
        :step="inputStep" 
        :readonly="readonly" >
      <span class="calendar-icon" style="position: absolute; top: 21px; right: 10px; transform: translateY(-50%); cursor: pointer;">
        <i class="fa fa-calendar"></i>
      </span>
    </div>
    </div>
    <div v-else>
      <input 
      v-if="!iconSrc && id" 
      :id="`${id}`" 
      @focusin="setClass ? setClass(id) : ''" 
      @focusout="unsetClass ? unsetClass(id) : ''" 
      class="c-input" 
      :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
      :style="inputStyle" 
      :value="value" 
      :placeholder="placeholder" 
      :type="type" 
      @input="$emit('input',$event.target.value)" 
      :maxlength="maxlength" 
      :min="inputMin" 
      :max="inputMax" 
      :step="inputStep" 
      :readonly="readonly" 
      :required="required"
      :disabled="disabled">
    <input 
      v-else-if="!iconSrc && !id" 
      @focusin="setClass ? setClass(id) : ''" 
      @focusout="unsetClass ? unsetClass(id) : ''" 
      @blur="$emit('blur', $event)"
      class="c-input" 
      :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
      :style="inputStyle" 
      :value="value" 
      :placeholder="placeholder" 
      :type="type" 
      @input="$emit('input',$event.target.value)" 
      :maxlength="maxlength" 
      :min="inputMin" 
      :max="inputMax" 
      :step="inputStep" 
      :readonly="readonly" 
      :required="required"
      :disabled="disabled">
    <div v-else>
      <input 
        v-if="id" 
        :id="`${id}`" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        style="padding-right: 50px" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :min="inputMin" 
        :max="inputMax" 
        :step="inputStep" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled">
      <input 
        v-else @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        style="padding-right: 50px" :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :min="inputMin" 
        :max="inputMax" 
        :step="inputStep" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled">
      <img class="c-input-icon" :src="iconSrc">
    </div>
    </div>
  </div>
</div>
